import { render, staticRenderFns } from "./TextAndCarousel.vue?vue&type=template&id=016fd9f1"
import script from "./TextAndCarousel.vue?vue&type=script&lang=js"
export * from "./TextAndCarousel.vue?vue&type=script&lang=js"
import style0 from "./TextAndCarousel.vue?vue&type=style&index=0&id=016fd9f1&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports